import type { ReactNode } from 'react';

// Glass pill shell for the header's right-slot buttons (repackz-handoff §7.3:
// 36 tall `glassPill`, radius 60, 13/600 on every width). Horizontal padding
// differs per pill, so callers pass it via `className`.
const PILL_SHELL =
  'inline-flex h-9 items-center justify-center cursor-pointer whitespace-nowrap rounded-[60px] ' +
  'border-[0.5px] border-solid [border-color:var(--glass-panel-rim)] [background:var(--glass-pill-fill)] backdrop-blur-[27px] ' +
  'text-[13px] font-semibold text-white transition-opacity hover:opacity-90';

export interface HeaderPillButtonProps {
  // `| undefined` so callers can forward their own optional onClick under
  // exactOptionalPropertyTypes without a conditional spread.
  onClick?: (() => void) | undefined;
  ariaLabel?: string | undefined;
  /** Per-pill horizontal padding (and any other overrides). */
  className?: string | undefined;
  children: ReactNode;
}

/**
 * Glass pill primitive shared by {@link LoginPill} and {@link MyPacksPill}.
 * Both render the identical frosted shell — only the padding and contents
 * differ — so the shell lives here once.
 */
export function HeaderPillButton({
  onClick,
  ariaLabel,
  className = '',
  children,
}: HeaderPillButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={PILL_SHELL + (className ? ' ' + className : '')}
    >
      {children}
    </button>
  );
}
